import styles from './styles.module.scss'

export default function PageSection({
  isThinSpacing,
  classes,
  children
}: {
  isThinSpacing?: boolean
  classes?: string
  children: React.ReactNode
}) {
  return (
    <section
      className={`${styles.SectionSpacing} ${
        isThinSpacing ? styles.SectionSpacingThin : ''
      } ${classes || ''}`}
    >
      {children}
    </section>
  )
}
